(() => {
  const units = new Map();
  const key = picker => `${picker.dataset.sectionId}:${picker.dataset.productId}`;
  const normalize = value => String(value || '').replace(/^US\s*/i, '').trim().toUpperCase();
  function inches(value) {
    const clean = String(value).replace(/[“”"]/g, '').trim();
    const m = clean.match(/^(\d+(?:\.\d+)?)(?:\s+(\d+)\/(\d+))?$/);
    return m ? Number(m[1]) + (m[2] ? Number(m[2]) / Number(m[3]) : 0) : NaN;
  }
  function format(value, unit) {
    if (unit === 'cm') return (value * 2.54).toFixed(1);
    const fraction = { '.25': '¼', '.5': '½', '.75': '¾' }[String(value % 1).replace(/^0/, '')];
    return fraction ? `${Math.floor(value)} ${fraction}` : String(value);
  }
  function render(picker) {
    if (!picker || !picker.isConnected) return;
    const panel = picker.querySelector('[data-iv-size-comparison]');
    const modal = picker.querySelector('.yuanqi-size-chart-modal');
    if (!panel || !modal) return;
    const unit = picker.dataset.ivMeasurementUnit || units.get(key(picker)) || 'in';
    // Read the existing chart, retaining its unconverted values as the single source of truth.
    const rows = [...modal.querySelectorAll('tbody tr')].map(row => {
      const cells = [...row.cells];
      const values = cells.slice(4, 8).map(cell => {
        if (!cell.dataset.inches) cell.dataset.inches = cell.textContent.trim();
        return inches(cell.dataset.inches);
      });
      return { size: normalize(cells[0]?.textContent), values, cells: cells.slice(4, 8) };
    }).filter(row => row.values.length === 4 && row.values.every(Number.isFinite));
    rows.forEach(row => row.cells.forEach((cell, i) => { cell.textContent = unit === 'in' ? cell.dataset.inches : `${format(row.values[i], unit)} cm`; }));
    modal.querySelectorAll('[data-yuanqi-unit]').forEach(b => {
      b.classList.toggle('is-active', b.dataset.yuanqiUnit === unit);
      b.setAttribute('aria-pressed', String(b.dataset.yuanqiUnit === unit));
    });
    panel.querySelectorAll('[data-iv-size-unit]').forEach(b => b.setAttribute('aria-pressed', String(b.dataset.ivSizeUnit === unit)));
    const option = picker.querySelector('[data-ivellora-size-option]');
    const selected = normalize(option?.querySelector('input:checked')?.value || option?.querySelector('select')?.value);
    const customFields = [...picker.querySelectorAll('[data-custom-size-field]')].filter(f => !f.disabled);
    const custom = picker.querySelector('[data-custom-size-property]')?.disabled === false && customFields.length > 0;
    const selectedLabel = option?.querySelector('[data-iv-selected-size]');
    if (selectedLabel) selectedLabel.textContent = custom ? ': Custom size' : selected ? `: US ${selected}` : '';
    if (custom) { if (!panel.hidden) panel.hidden = true; return; }
    if (panel.hidden) panel.hidden = false;
    panel.querySelector('[data-iv-measure-title]').textContent = custom ? 'Your saved measurements' : 'Your size, at a glance';
    const index = rows.findIndex(row => row.size === selected);
    panel.querySelector('[data-iv-standard-comparison]').hidden = custom || index < 0;
    const missing = panel.querySelector('[data-iv-size-missing]');
    missing.hidden = custom || index >= 0;
    missing.textContent = selected ? 'Measurements are not available for this size. Please refer to the Size Guide or contact us.' : 'Choose a size to see its measurements.';
    const summary = panel.querySelector('[data-iv-custom-summary]');
    summary.hidden = !custom;
    summary.replaceChildren();
    if (custom) {
      customFields.forEach(field => {
        const item = document.createElement('div'), label = document.createElement('small'), value = document.createElement('strong');
        label.textContent = field.name.replace(/^properties\[/, '').replace(/ \(in\)\]$/, '');
        value.textContent = `${format(Number(field.value), unit)} ${unit}`;
        item.append(label, value); summary.append(item);
      });
      const edit = document.createElement('button'); edit.type = 'button'; edit.dataset.ivEditCustom = ''; edit.textContent = 'Edit measurements ↗'; summary.append(edit);
    }
    const body = panel.querySelector('[data-iv-size-rows]'); body.replaceChildren();
    if (index >= 0 && !custom) {
      const start = Math.max(0, Math.min(index - 1, rows.length - 3));
      rows.slice(start, start + 3).forEach(row => {
        const tr = document.createElement('tr'), th = document.createElement('th'); th.scope = 'row'; th.textContent = row.size;
        if (row.size === selected) { tr.className = 'is-selected'; tr.setAttribute('aria-current', 'true'); }
        tr.append(th); row.values.forEach(value => { const td = document.createElement('td'); td.textContent = format(value, unit); tr.append(td); }); body.append(tr);
      });
    }
    const announcement = panel.querySelector('[data-iv-size-announcement]');
    const message = custom ? `Custom measurements in ${unit}` : `US ${selected}, measurements in ${unit}`;
    if (announcement.textContent !== message) announcement.textContent = message;
  }
  function init() { document.querySelectorAll('variant-picker').forEach(render); }
  document.addEventListener('click', event => {
    const b = event.target.closest?.('[data-iv-size-unit], [data-yuanqi-unit], [data-iv-measure-guide]');
    const picker = b?.closest('variant-picker'); if (!picker) return;
    if (b.hasAttribute('data-iv-measure-guide')) {
      const modal = picker.querySelector('.yuanqi-size-chart-modal');
      modal.showModal(); modal.querySelector('[data-yuanqi-size-tab="guide"]')?.click();
    } else { const unit = b.dataset.ivSizeUnit || b.dataset.yuanqiUnit; units.set(key(picker), unit); picker.dataset.ivMeasurementUnit = unit; render(picker); }
  });
  document.addEventListener('change', event => {
    const picker = event.target.closest?.('variant-picker');
    if (picker) requestAnimationFrame(() => render(picker));
  });
  document.addEventListener('ivellora:measurements', event => render(event.target.closest('variant-picker')));
  let queued = false;
  new MutationObserver(records => {
    if (queued || !records.some(r =>
      (r.type === 'attributes' && r.target.matches('[data-iv-size-comparison]') && r.target.hidden && !r.target.closest('variant-picker')?.querySelector('[data-iv-custom-active]')) ||
      (r.type === 'childList' && [...r.addedNodes].some(n => n instanceof Element && (n.matches('variant-picker, [data-iv-size-comparison], [data-ivellora-size-option], .yuanqi-size-chart-modal') || n.querySelector('variant-picker, [data-iv-size-comparison]'))))
    )) return;
    queued = true; queueMicrotask(() => { queued = false; init(); });
  }).observe(document.getElementById('MainContent') || document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['hidden'] });
  document.addEventListener('ivellora:variant-picker-updated', init);
  document.addEventListener('shopify:section:load', init); init();
})();
